import { createSelector } from 'reselect';

const getMergeRequestsFromState = (state) => state.user?.mergeRequests || [];

export const getMergedAccountsList = createSelector(
    [getMergeRequestsFromState],
    (mergeRequests) => {
        const mergedRequests = mergeRequests.filter(
            (request) => request.status === 'merged'
        );

        const mergedAccounts = {};

        mergedRequests.forEach((request) => {
            const secondaryAccount = request.secondary_account;
            const primaryAccount = request.primary_account;

            if (secondaryAccount?.id) {
                mergedAccounts[secondaryAccount.id] = {
                    id: secondaryAccount.id,
                    email:
                        secondaryAccount.email || secondaryAccount.user?.email,
                    username: secondaryAccount.user?.username,
                    public_display_name:
                        secondaryAccount.user?.public_display_name,
                    avatar_image_url: secondaryAccount.user?.avatar_image_url,
                    mergedInto: primaryAccount?.id,
                    mergedIntoEmail:
                        primaryAccount?.email || primaryAccount?.user?.email
                };
            }
        });

        return mergedAccounts;
    }
);

export const getUserMergedFromInfo = (mergedAccounts, journalOrTagUserId) => {
    if (!mergedAccounts || !journalOrTagUserId) {
        return null;
    }

    return mergedAccounts[journalOrTagUserId] || null;
};

export const getMergedAccountDisplayName = (mergedAccount) => {
    if (!mergedAccount) {
        return null;
    }

    return (
        mergedAccount.public_display_name ||
        mergedAccount.username ||
        mergedAccount.email
    );
};
